import { render } from "./Basic_Info_static.vue?vue&type=template&id=03bc1712&scoped=true"
import script from "./Basic_Info_static.vue?vue&type=script&lang=js"
export * from "./Basic_Info_static.vue?vue&type=script&lang=js"

import "./Basic_Info_static.vue?vue&type=style&index=0&id=03bc1712&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03bc1712"]])

export default __exports__